import { logger } from '#pplx/frontend/logger/browser.js';
const isSameDomain = (url) => {
    try {
        const redirectUrl = new URL(url, window.location.href);
        return redirectUrl.hostname === window.location.hostname;
    }
    catch (error) {
        logger.warn(error);
        return false;
    }
};
/**
 * Processes and validates a query redirect parameter.
 * @param redirect - The redirect query parameter.
 * @returns The validated redirect URL if same-origin, else `'/'`.
 */
export const cleanQueryRedirect = ({ redirect, }) => {
    const redirectUrl = typeof redirect === 'string' ? redirect : redirect?.[0];
    if (!redirectUrl || typeof redirectUrl !== 'string') {
        return '/';
    }
    else if (isSameDomain(redirectUrl)) {
        return redirectUrl;
    }
    return '/';
};
//# sourceMappingURL=cleanQueryRedirect.js.map